import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the initial state
interface DashboardState {
  isLoading: boolean;
  error: string | null;
}
const initialState: DashboardState = {
  isLoading: false,
  error: null,
};
// Create a slice
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// Export the actions and reducer
export const { setLoading, setError } = dashboardSlice.actions;
export default dashboardSlice.reducer;
